module.exports = __webpack_public_path__ + "img/pm-logo.3b043b7c.png";